import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const LOADING_DURATION_MS = 420;

function PageTransitionLoader() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setIsLoading(true);
    const timeoutId = window.setTimeout(() => {
      setIsLoading(false);
    }, LOADING_DURATION_MS);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [location.pathname, location.search, location.hash]);

  if (!isLoading) {
    return null;
  }

  return (
    <div className="page-transition-loader" role="status" aria-live="polite">
      <div className="page-transition-loader__panel">
        <img
          className="page-transition-loader__cat"
          src="/images/dream-loader.gif"
          alt=""
          aria-hidden="true"
        />
        <span>ກຳລັງໂຫຼດ...</span>
      </div>
    </div>
  );
}

export default PageTransitionLoader;
